﻿import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

import {connect} from 'react-redux';
import {pageCurrentStepAction} from '../../../State/actions';

import {insuranceGuideUpdateFormDataAction, submitInsuranceGuideAction} from '../State/actions';

import Form from '../../../../vendor/react-validation/components/form';
import ValidationButton from '../../../Forms/Components/ValidationButton';
import BackButton from '../Components/BackButton';

import getFormValues from '../../../Forms/getFormValues';
import {scrollToTop} from '../../../Utils/scroll';

export class GuideFormBase extends React.Component {
    constructor(props) {
        super(props);

        this.form = null;
        this.validationTimer = null;
        this.validationDelay = 2000;
    }

    static get propTypes() {
        return {
            scrollToTopOnContinue: PropTypes.func,
            submitOnStep: PropTypes.number
        }
    }

    handleFormChange = (event) => {
        // ...
    }

    previousSection = (e) => {
        e.preventDefault();
        this.props.setSectionFormData(getFormValues(this.form));
        this.props.setCurrentStep(this.props.currentStep - 1);
    }

    submitSection = (e) => {
        e.preventDefault();
        this.props.setSectionFormData(getFormValues(this.form));

        if (this.props.currentStep == this.props.submitOnStep) {
            this.props.submitGuide();
        } else if (this.props.scrollToTopOnContinue() && window.innerWidth < definitions.breaks.small && this.props.currentStep > 0) {
            scrollToTop(350).then(() => this.props.setCurrentStep(this.props.currentStep + 1));
        } else {
            this.props.setCurrentStep(this.props.currentStep + 1);
        }
    }

    startValidationTimer = () => {
        if (!this.validationTimer) {
            this.validationTimer = setTimeout(this.form.validateAll, this.validationDelay);
        }
    }

    cancelValidationTimer = () => {
        if (this.validationTimer) {
            clearTimeout(this.validationTimer);
        }
    }

    stepFormWrapper = (props) => {
        return (
            <div>
                <h2 className="h3">{`${this.props.currentStep + 1}. ${props.heading}`}</h2>

                <GuideFormWrapper>
                    <Form ref={el => { this.form = el; }} onChange={this.handleFormChange} onSubmit={e => this.submitSection(e)}>

                        {props.children}

                        <ButtonWrapper>
                            {this.props.currentStep > 0 &&
                                <BackButton onClick={this.previousSection}>
                                    Tillbaka
                                </BackButton>
                            }

                            <ValidationButton                             
                                onMouseEnter={this.startValidationTimer}
                                onMouseLeave={this.cancelValidationTimer}
                            >
                                Gå vidare
                            </ValidationButton>
                        </ButtonWrapper>
                    </Form>
                </GuideFormWrapper>
            </div>
        );
    }
}

// state

const mapStateToProps = (guideStep) => {
    return (state) => {
        return {
            currentStep: state.pageCurrentStep,
            formData: state.insuranceGuideFormData.formData[`step${guideStep}`]
        }
    }
};

const mapDispatchToProps = (guideStep) => {
    return (dispatch) => {
        return {
            setCurrentStep: (step) => dispatch(pageCurrentStepAction(step)),
            setSectionFormData: (data) => dispatch(insuranceGuideUpdateFormDataAction(({[`step${guideStep}`]: data}))),
            submitGuide: () => dispatch(submitInsuranceGuideAction())
        };
    }
};

export const connectForm = (options) => connect(mapStateToProps(options.guideStep), mapDispatchToProps(options.guideStep))(options.formClass);

// styles

const GuideFormWrapper = styled.div`
    display: inline-block;
    margin-top: 40px;
    margin-bottom: 5px;

    ${mediaQuery.small(`
        margin-top: 20px;
        margin-bottom: 65px;
    `)};
`;

const ButtonWrapper = styled.div`
    margin: 40px auto 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: auto;
`;
